import React from "react";
import { useNavigate } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";

const ManageCycle = ({ product }) => {
  const navigate = useNavigate();
  const { _id, name, price, image, description, quantity, supplier } = product;
  const deleteHandeler = (id) => {
    const confirm = window.confirm("Are You Sure");
    if (confirm) {
      fetch(`https://intense-stream-06695.herokuapp.com/user/${id}`, {
        method: "delete",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.deletedCount > 0) {
            navigate("/");
            alert("Delete success");
          }
        });
    }
  };
  return (
    <div>
      <div className="mx-5 mb-10 bg-gray-200 rounded-xl  relative shadow-xl h-[510px]">
        <img
          className="rounded-t-xl w-full mt-3 h-[350px]"
          src={image}
          alt=""
        />
        <h3 className="text-xl  text-center font-bold pt-1">{name}</h3>
        {/* <div className="text-xl font-sans px-5 ">
          {description.slice(0, 150)}{" "}
          <span className="text-orange-400">Read More...</span>
        </div> */}
        <div className="absolute bottom-0 ">
          <div className="text-xl font-sans px-5 ">
            <span className="text-xl">Price: $</span>
            {price}
          </div>
          <div className="text-xl font-sans px-5 ">
            <span className="text-xl">Quantity: </span>
            {quantity} Unit
          </div>
          <div className="text-xl font-sans px-5 mb-5">
            <span className="text-xl">Supplier: </span>
            {supplier}
          </div>
        </div>
        <div className=" mt-5 flex justify-end">
          <button
            onClick={() => navigate(`/update/${_id}`)}
            className=" bg-red-500 hover:bg-slate-400  text-white px-2  rounded-xl "
          >
            UPDATE ITEM
          </button>
          <button
            onClick={() => deleteHandeler(_id)}
            className=" text-red-500 text-3xl p-2  rounded-xl ml-6 transition ease-in-out delay-150  hover:-translate-y-2 hover:scale-110 duration-300"
          >
            <MdDeleteForever />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageCycle;
